import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, formatEUR } from "@/lib/api";
import { ArrowLeft, Clock, ScanLine } from "lucide-react";

const refLabel = (o, tableMap) => {
  if (o.takeaway) return "Asporto";
  if (o.table_id) return tableMap[o.table_id] ? `Tavolo ${tableMap[o.table_id]}` : "Tavolo";
  if (o.preconto_number) return `Preconto n. ${o.preconto_number}`;
  return "Banco";
};

export default function OpenOrders() {
  const [orders, setOrders] = useState(null);
  const [tableMap, setTableMap] = useState({});

  useEffect(() => {
    api.get("/orders", { params: { status: "open", limit: 200 } }).then((r) => setOrders(Array.isArray(r.data) ? r.data : []));
    api.get("/tables").then((r) => {
      const m = {};
      (Array.isArray(r.data) ? r.data : []).forEach((t) => { m[t.id] = t.name || t.number; });
      setTableMap(m);
    }).catch(() => {});
  }, []);

  const total = (Array.isArray(orders) ? orders : []).reduce((s, o) => s + (o.total || 0), 0);

  return (
    <div className="p-8 lg:p-12">
      <Link to="/dashboard" data-testid="open-orders-back" className="inline-flex items-center gap-2 text-sm text-velta-mute hover:text-velta-ink mb-6">
        <ArrowLeft className="w-4 h-4" /> Panoramica
      </Link>
      <div className="flex items-start justify-between flex-wrap gap-6 mb-8">
        <div>
          <div className="text-xs font-mono uppercase tracking-[0.25em] text-velta-mute mb-3">In tempo reale</div>
          <h1 className="font-heading text-4xl font-bold tracking-tight mb-2">Conti aperti</h1>
          {orders && <p className="text-velta-mute">{orders.length} {orders.length === 1 ? "conto aperto" : "conti aperti"} · totale in sospeso <span className="font-mono font-semibold text-velta-ink">{formatEUR(total)}</span></p>}
        </div>
        <Link to="/cassa" data-testid="open-orders-pos-btn" className="inline-flex items-center gap-2 h-12 px-6 bg-[#1E2D5B] hover:bg-[#162244] text-white rounded-md font-medium btn-tactile">
          <ScanLine className="w-5 h-5" /> Apri Cassa
        </Link>
      </div>

      {orders && orders.length === 0 && (
        <div data-testid="open-orders-empty" className="bg-white border border-velta-border rounded-md p-12 text-center">
          <Clock className="w-10 h-10 text-velta-subtle mx-auto mb-4" strokeWidth={1.5} />
          <div className="font-heading text-xl font-semibold mb-1">Nessun conto aperto</div>
          <div className="text-sm text-velta-mute">Tutti i conti sono stati chiusi.</div>
        </div>
      )}

      {orders && orders.length > 0 && (
        <div className="bg-white border border-velta-border rounded-md overflow-x-auto pos-scroll">
          <table className="w-full text-sm min-w-[720px]" data-testid="open-orders-table">
            <thead>
              <tr className="border-b border-velta-border text-left text-xs font-mono uppercase tracking-widest text-velta-mute">
                <th className="px-5 py-3 font-medium">Riferimento</th>
                <th className="px-5 py-3 font-medium">Modalità</th>
                <th className="px-5 py-3 font-medium">Operatore</th>
                <th className="px-5 py-3 font-medium">Aperto il</th>
                <th className="px-5 py-3 font-medium text-right">Articoli</th>
                <th className="px-5 py-3 font-medium text-right">Totale</th>
              </tr>
            </thead>
            <tbody>
              {(Array.isArray(orders) ? orders : []).map((o) => (
                <tr key={o.id} data-testid={`open-order-row-${o.id}`} className="border-b border-velta-border last:border-0 hover:bg-velta-bg transition-colors">
                  <td className="px-5 py-3.5 font-medium text-velta-ink">{refLabel(o, tableMap)}</td>
                  <td className="px-5 py-3.5 font-mono text-xs uppercase text-velta-mute">{(o.mode || "").replace(/_/g, " ")}</td>
                  <td className="px-5 py-3.5 text-velta-mute">{o.operator_name || "—"}</td>
                  <td className="px-5 py-3.5 font-mono text-xs text-velta-mute">{o.created_at ? new Date(o.created_at).toLocaleString("it-IT", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" }) : "—"}</td>
                  <td className="px-5 py-3.5 text-right font-mono">{(Array.isArray(o.lines) ? o.lines : []).reduce((s, l) => s + (l.qty || 0), 0)}</td>
                  <td className="px-5 py-3.5 text-right font-mono font-semibold">{formatEUR(o.total)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
